import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";

const LANDING_BASE_URL = "https://sacra-visio.smart-tech.hr";

export default function LicenseQrCodePage() {
  const { licenseCode } = useParams();

  const qrValue = `${LANDING_BASE_URL}/${licenseCode ?? ""}`;

  return (
    <>
      <style>
        {`
          /* POS 80mm print styling */
          @media print {
            @page {
              size: 80mm auto;
              margin: 0;
            }

            html, body {
              margin: 0 !important;
              padding: 0 !important;
              background: #fff !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            /* Print only the receipt block to avoid long blank feed. */
            body * {
              visibility: hidden;
            }

            .pos-print-root,
            .pos-print-root * {
              visibility: visible;
            }

            .pos-print-root {
              position: static !important;
              width: 80mm !important;
              margin: 0 !important;
              overflow: visible !important;
            }

            html,
            body,
            .pos-page,
            .pos-print-root {
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
            }

            .pos-page {
              min-height: auto !important;
              padding: 0 !important;
              background: #fff !important;
            }

            .pos-receipt {
              width: 72mm;          /* common printable width on 80mm paper */
              margin: 0 auto;
              padding: 3mm 0 4mm;
              color: #111827;
            }

            .pos-topline {
              gap: 2.5mm !important;
              margin-bottom: 4mm !important;
            }

            .pos-topline-rule {
              height: 0.35mm !important;
              width: 18mm !important;
              background: #404040 !important;
            }

            .pos-topline-text {
              font-size: 3mm !important;
              line-height: 1 !important;
              letter-spacing: 0.04em !important;
            }

            .pos-title {
              font-size: 4.2mm !important;
              margin-bottom: 3mm !important;
              line-height: 1.1 !important;
            }

            .pos-subtitle {
              font-size: 2.8mm !important;
              line-height: 1.2 !important;
            }

            .pos-body {
              font-size: 3mm !important;
              line-height: 1.2 !important;
            }

            .pos-subtitle {
              margin-bottom: 5mm !important;
            }

            .pos-qrwrap {
              margin-bottom: 5mm !important;
              padding: 2mm !important;
              background: #fff !important;
              box-shadow: none !important;
            }

            .pos-qrwrap svg {
              width: 52mm !important;
              height: 52mm !important;
              display: block !important;
            }

            .pos-body {
              margin-bottom: 4mm !important;
            }

            .pos-qrwrap,
            .pos-qrwrap * {
              break-inside: avoid;
              page-break-inside: avoid;
            }
          }
        `}
      </style>

      <div className="pos-print-root pos-page min-h-screen bg-neutral-200 py-10 px-4">
        <div className="pos-receipt mx-auto w-full max-w-[640px] text-center text-neutral-900">
          <div className="pos-topline mb-8 flex items-center justify-center gap-4">
            <div className="pos-topline-rule h-[2px] w-24 bg-neutral-700" />
            <p className="pos-topline-text text-[30px] font-medium leading-none tracking-wide">
              OFFICIAL TOUR APP
            </p>
            <div className="pos-topline-rule h-[2px] w-24 bg-neutral-700" />
          </div>

          <h1 className="pos-title mb-6 text-[34px] font-medium leading-tight">Sacra Visio</h1>

          <p className="pos-subtitle mx-auto mb-14 max-w-[560px] text-[30px] leading-tight">
            Your digital guide to the Treasury od Split Cathedral
          </p>

          <div className="pos-qrwrap mx-auto mb-14 w-fit bg-white p-4 shadow-sm">
            <QRCode value={qrValue} size={260} />
          </div>

          <p className="pos-body mx-auto mb-10 max-w-[560px] text-[30px] leading-tight">
            This QR code is used to download the app and activate it.
            <br />
            After installation, scan the same code
            <br />
            within the app to unlock it.
          </p>

          <p className="pos-body mx-auto max-w-[560px] text-[30px] leading-tight">
            Note: the same QR code is used in both steps.
          </p>
        </div>
      </div>
    </>
  );
}
